import { useQueryClient } from '@tanstack/react-query';
import { PROGRAMS } from '../constants/programs';
import { createApiKeyHooks } from './api/useApiKeyHooks';
import { createAppsheetHooks } from './api/useAppsheetHooks';
import { createCacheHooks } from './api/useCacheHooks';
import { createCancelledBacsHooks } from './api/useCancelledBacsHooks';
import { createBuySellHooks } from './api/useBuySellHooks';
import { createCredentialsHooks } from './api/useCredentialsHooks';
import { createCronHooks } from './api/useCronHooks';
import { createDbHooks } from './api/useDbHooks';
import { createDiHooks } from './api/useDiHooks';
import { createEmailHooks } from './api/useEmailHooks';
import { createEnrollmentHooks } from './api/useEnrollmentHooks';
import { createMetricsHooks } from './api/useMetricsHooks';
import { createReportEmailScheduleHooks } from './api/useReportEmailScheduleHooks';
import { createReportsHooks } from './api/useReportsHooks';
import { createSettingsHooks } from './api/useSettingsHooks';
import { createVmtHooks } from './api/useVmtHooks';
import { createWebsiteOwnershipConfigHooks } from './api/useWebsiteOwnershipConfigHooks';
import { fetchAllSnapshot, fetchDealerSnapshot, fetchProgramSnapshot, getEnrollmentByProgram, getEnrollmentForAllPrograms } from './api/enrollmentApi';

export { PROGRAMS };
export { getEnrollmentByProgram, getEnrollmentForAllPrograms };

const useApi = () => {
    const queryClient = useQueryClient();

    return {
        ...createCredentialsHooks({ queryClient }),
        ...createDiHooks(),
        ...createEmailHooks({ queryClient }),
        ...createApiKeyHooks({ queryClient }),
        ...createSettingsHooks({ queryClient }),
        ...createEnrollmentHooks({ queryClient }),
        ...createCacheHooks({ queryClient }),
        ...createCancelledBacsHooks({ queryClient }),
        ...createBuySellHooks({ queryClient }),
        ...createVmtHooks({ queryClient }),
        ...createAppsheetHooks(),
        ...createMetricsHooks({ queryClient }),
        ...createReportEmailScheduleHooks({ queryClient }),
        ...createReportsHooks({ queryClient }),
        ...createDbHooks(),
        ...createCronHooks({ queryClient }),
        ...createWebsiteOwnershipConfigHooks({ queryClient }),
        fetchProgramSnapshot,
        fetchAllSnapshot,
        fetchDealerSnapshot,
    };
};

export default useApi;
